<h2 mat-dialog-title class="text-center">{{ "Groupe : "+groupe.groupe }}</h2>
<mat-dialog-content id="modalDialog" #modalDialog >
<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
    <mat-card-header class="row mx-1">
        <div class="col-4">
        </div>
        <app-search-bar-component class="col-6" (searchBarValue)="applyFilter($event)" appearance="outline"></app-search-bar-component>
        <button matButton type="button" class="bg-mat-green col-2 py-4" (click)="openShareModal()">Distribution</button>
    </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
       @if (loading) {
        <div class="table-loading-overlay d-flex align-items-center justify-content-center">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
        }

      <!---->
      <div>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Date </th>
          <td mat-cell *matCellDef="let row"  data-label="Date"> {{row.date | date:'medium'}} </td>
        </ng-container>
        <!-- -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Type </th>
          <td mat-cell *matCellDef="let row"  data-label="Type"> {{row.type}} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="qte">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Quantite </th>
          <td mat-cell *matCellDef="let row"  data-label="Qte"> {{row.qte }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="reste">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Reste </th>
          <td mat-cell *matCellDef="let row"  data-label="Reste"> {{row.reste }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="attestation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Attestation </th>
          <td mat-cell *matCellDef="let row"  data-label="Attestation"> {{row.attestation_range | rangePipe}} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="carte_rose">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Carte rose </th>
          <td mat-cell *matCellDef="let row"  data-label="Carte rose "> {{row.carte_rose_range | rangePipe}} </td>
        </ng-container>

       <!-- -->
        <ng-container matColumnDef="collaborateur">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Collaborateur </th>
          <td mat-cell *matCellDef="let row"  data-label="Collaborateur"> {{row.collaborateur}} </td>
        </ng-container>


        <!-- -->
        <ng-container matColumnDef="compagnie">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Compagnie </th>
          <td mat-cell *matCellDef="let row"  data-label="Compagnie"> {{row.compagnie}} </td>
        </ng-container>


        <!-- -->
        <ng-container matColumnDef="editor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Editeur </th>
          <td mat-cell *matCellDef="let row"  data-label="Editeur"> {{row.editor}} </td>
        </ng-container>

        <!-- 
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Action </th>
          <td mat-cell *matCellDef="let row"  data-label="Action">
                <button mat-flat-button color="warn" (click)="onDelete()" [disabled]="row.qte!=row.reste">
                     <mat-icon>delete_outline</mat-icon>
                </button>
          </td>
        </ng-container>-->


        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
        </tr>
            </table>
      </div>      </div>
  </mat-card-content>

</mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton mat-dialog-close  class="bg-mat-red m-3" >Fermer</button>
</mat-dialog-actions>
